import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#4A6DB7',
            light: '#A2B7E4',
            dark: '#304C89'
        },
        secondary: {
            main: '#d7ccc8',
            light: '#fffffb',
            dark: '#a69b97'
        }
    }
});

export default theme